import { Environment } from "@libs/shares/models/models";

export const environment = {
  production: true,
  name: Environment.PRODUCTION,
  intercom: {
    appId: "zgn72x6y"
  },
  apiBaseUrl: "/api",
  cookieDomain: ".1inch.dev",
  portal: {
    url: "https://portal.1inch.dev"
  },
  gateway: {
    url: "https://api.1inch.dev"
  },
  legal: {
    commercialTermsOfService: "/assets/legal-docs/terms_of-service_commercial_api_20250328.pdf",
    termsOfService: "/assets/legal-docs/terms_of_service_public_api_20250508.pdf",
    privacyPolicy: "/assets/legal-docs/privacy_policy_20241211.pdf"
  },
  unleash: {
    url: "https://unleash-edge.1inch.io/api/frontend",
    clientKey: "devportal:production.6f2aec0dcd76ab8b4c1d1e91dde33cfa5a984eb5a5e144f0d7787aae",
    environment: "production"
  },
  walletConnectProjectId: "844322fc5f92cfa1144a75330c919ebd"
};
